import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Project } from '@/types/project'

export function getProjects(): Promise<AxiosResponse<Project[]>> {
  return instance.get(`/iam/project`)
}
